module.exports = __webpack_public_path__ + "static/media/userSelected.8321295f.svg";